"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.signedExtensions = exports.typesBundleForPolkadot = exports.typesBundle = exports.typesAlias = exports.rpc = exports.types = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _ormlTypeDefinitions = require("@open-web3/orml-type-definitions");

var _utils = require("@open-web3/orml-type-definitions/utils");

var _signedExtensions = require("./signedExtensions");

var _aSharePrimitives = _interopRequireDefault(require("./aSharePrimitives"));

var _bid = _interopRequireDefault(require("./bid"));

var _bridgeEos = _interopRequireDefault(require("./bridgeEos"));

var _bancor = _interopRequireDefault(require("./bancor"));

var _bridgeIost = _interopRequireDefault(require("./bridgeIost"));

var _flexibleFee = _interopRequireDefault(require("./flexibleFee"));

var _minterReward = _interopRequireDefault(require("./minterReward"));

var _salp = _interopRequireDefault(require("./salp"));

var _stakingReward = _interopRequireDefault(require("./stakingReward"));

var _swap = _interopRequireDefault(require("./swap"));

var _tokens = _interopRequireDefault(require("./tokens"));

var _vesting = _interopRequireDefault(require("./vesting"));

var _vsbondAuction = _interopRequireDefault(require("./vsbondAuction"));

var _vtokenMint = _interopRequireDefault(require("./vtokenMint"));

var _zenlinkProtocol = _interopRequireDefault(require("./zenlinkProtocol"));

var _runtime = _interopRequireDefault(require("./runtime"));

var _currencies = _interopRequireDefault(require("./currencies"));

var _liquidityMining = _interopRequireDefault(require("./liquidityMining"));

var _xTokens = _interopRequireDefault(require("./xTokens"));

var _bifrost = _interopRequireDefault(require("./spec/bifrost"));

var _asgard = _interopRequireDefault(require("./spec/asgard"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

const additionalOverride = {
  Keys: 'SessionKeys1'
};
const bifrostDefs = {
  bid: _bid.default,
  bridgeEos: _bridgeEos.default,
  bancor: _bancor.default,
  bridgeIost: _bridgeIost.default,
  currencies: _currencies.default,
  flexibleFee: _flexibleFee.default,
  minterReward: _minterReward.default,
  salp: _salp.default,
  stakingReward: _stakingReward.default,
  swap: _swap.default,
  tokens: _tokens.default,
  vesting: _vesting.default,
  runtime: _runtime.default,
  vsbondAuction: _vsbondAuction.default,
  vtokenMint: _vtokenMint.default,
  zenlinkProtocol: _zenlinkProtocol.default,
  aSharePrimitives: _aSharePrimitives.default,
  liquidityMining: _liquidityMining.default,
  xTokens: _xTokens.default
};

const types = _objectSpread(_objectSpread(_objectSpread({}, _ormlTypeDefinitions.types), (0, _utils.typesFromDefs)(bifrostDefs)), additionalOverride);

exports.types = types;
const rpc = (0, _utils.jsonrpcFromDefs)(bifrostDefs, _objectSpread({}, _ormlTypeDefinitions.rpc));
exports.rpc = rpc;
const typesAlias = (0, _utils.typesAliasFromDefs)(bifrostDefs, _objectSpread({}, _ormlTypeDefinitions.typesAlias));
exports.typesAlias = typesAlias;

function getBundle(versioned) {
  return {
    rpc,
    types: [...versioned].map(version => {
      return {
        minmax: version.minmax,
        types: _objectSpread(_objectSpread({}, types), version.types)
      };
    }),
    alias: typesAlias
  };
}

const typesBundle = {
  spec: {
    bifrost: getBundle(_bifrost.default),
    asgard: getBundle(_asgard.default)
  }
}; // Type overrides have priority issues

exports.typesBundle = typesBundle;
const typesBundleForPolkadot = {
  spec: {
    bifrost: getBundle(_bifrost.default),
    asgard: getBundle(_asgard.default)
  }
};
exports.typesBundleForPolkadot = typesBundleForPolkadot;
const signedExtensions = _signedExtensions.signedExtensions;
exports.signedExtensions = signedExtensions;